import { render, staticRenderFns } from "./document.vue?vue&type=template&id=246cddcb&"
import script from "./document.vue?vue&type=script&lang=js&"
export * from "./document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('246cddcb')) {
      api.createRecord('246cddcb', component.options)
    } else {
      api.reload('246cddcb', component.options)
    }
    module.hot.accept("./document.vue?vue&type=template&id=246cddcb&", function () {
      api.rerender('246cddcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/document.vue"
export default component.exports